import * as constants from './constants';
import http from '../../../utils/request';

const getResourcesData = (result) => ({
  type: constants.GET_RESOURCES_DATA,
  resoucers: result.categories,
  head: result.head,
});

export const fetchResourcesData = () => {
  return (dispatch) => {
    http('post','/achieve/doctor/lists').then((res) => {
      const result = res.data;
      // console.log(result);
      dispatch(getResourcesData(result));
    });
  }
};